import { buttonSizes, buttonVariations } from './variations'

export const applySizes = (props, size, styles) => {
  let targetSize = size ?? buttonSizes.SMALL
  if (!size) {
    for (const item of Object.values(buttonSizes)) {
      if (props[item]) {
        targetSize = item
      }
    }
  }
  return styles[targetSize]
}

export const applyVariations = (props, variation, styles) => {
  let targetVaration = variation ?? buttonVariations.PRIMARY
  if (!variation) {
    for (const item of Object.values(buttonVariations)) {
      if (props[item]) {
        targetVaration = item
      }
    }
  }
  return styles[targetVaration]
}
